export const Logo = ({ width, height }: { width: string; height: string }) => {
  return (
    <svg width={width} height={height} fill="none" viewBox="0 0 56 56">
      <path
        fill="#7C01FF"
        d="M50 42.561v-13.69a6.47 6.47 0 00-1.922-4.61L32.433 8.823a6.3 6.3 0 00-8.866 0L7.922 24.26A6.47 6.47 0 006 28.87v13.69C6 46.114 8.84 49 12.36 49h31.29c3.51 0 6.35-2.876 6.35-6.439z"
      ></path>
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M15.156 33.89v-4.022h-2.903v10.858h2.882v-4.054c.02-.892.638-1.317 1.201-1.317.575 0 1.01.266 1.042 1.136v4.246h2.85V36.48c0-2.579-1.467-3.587-3.02-3.587-.914 0-1.51.297-2.052.998zm15.047-.817h-2.69l-.16.818c-.404-.627-1.16-.998-2.254-.998-2.233 0-3.733 1.74-3.733 4.012 0 2.24 1.266 3.842 3.52 3.98.861.043 1.882-.223 2.541-.966l.128.828h2.648v-7.674zm-4.434 5.509c-.862 0-1.542-.605-1.542-1.677s.69-1.688 1.542-1.698c1.008 0 1.582.668 1.582 1.698 0 .902-.617 1.677-1.584 1.677zm8.985-4.861c.425-.51 1.148-.828 2.137-.828 2.244 0 3.733 1.666 3.733 4.012 0 2.42-1.266 3.842-3.52 3.98-.861.043-1.882-.222-2.542-.965l-.127.827h-2.552v-10.88h2.86v3.854h.01zm-.064 3.27c0 .806.574 1.602 1.542 1.602.861 0 1.542-.605 1.542-1.677s-.68-1.699-1.542-1.699c-1.01 0-1.542.84-1.542 1.773zm10.092-3.8v7.557H41.9V33.19h2.882z"
        clipRule="evenodd"
      ></path>
      <path
        fill="#FF5958"
        d="M43.388 15.603c1.187 0 2.148-.96 2.148-2.144a2.146 2.146 0 00-2.148-2.144c-1.186 0-2.148.96-2.148 2.144 0 1.184.962 2.144 2.148 2.144z"
      ></path>
    </svg>
  );
};
